import { ComponentStyleConfig } from '@chakra-ui/react'

export const Modal: ComponentStyleConfig = {
  baseStyle: {
    dialog: { px: 6, py: 4, borderRadius: '12px' },
    dialogContainer: { alignItems: 'center' },
    header: {
      position: 'relative',
      color: 'product.text.dark.header',
      fontSize: 'product.lg',
      fontWeight: 'semibold',
      paddingX: 0,
      paddingTop: 0,
      paddingBottom: 4,
      '&:after': {
        content: '""',
        position: 'absolute',
        left: -2,
        bottom: 0,
        height: '1px',
        width: 'calc(100% + 1rem)',
        background: 'product.border.solid',
      },
    },
    closeButton: {
      top: 4,
      right: 5,
      color: 'text.dark.bodySolid',
      margin: 0,
      size: 'sm',
      _disabled: {
        opacity: 0.5,
        _hover: { bg: 'none' },
      },
      _focusVisible: {
        borderWidth: '1px',
        borderColor: 'product.border.solid',
        boxShadow: 'outline',
      },
    },
    body: { marginY: 4, padding: 0 },
    footer: { padding: 0, paddingTop: 7 },
  },
}
